import { tViews } from "../../../../../utils/table";

const getDeviceTableConfig = () => ({
  title: tViews('applicationOverviewLabelTopDevices'),
  subTitle: tViews('applicationOverviewLabelTopDevices'),
  columns: [
    {
      title: tViews('applicationOverviewLabelDevices'),
      colSpan: 1,
      property: "local_host_name",
      type: "string",
      format: "link",
      maxLength: 15,
      width: "30%"
    },
    {
      title: `% ${tViews('dashletSiteViewAvailability')}`,
      colSpan: 2,
      property: "curr_up_percent",
      type: "number",
      format: "percent",
      theme: "availability",
      width: "0%"
    },
    {
      title: null,
      colSpan: 0,
      property: "change_percentage",
      type: "number",
      format: "changePercent",
      theme: "changeQuality",
      width: "15%"
    },
    {
      title: tViews('applicationOverviewLabelBandwidthMbps'),
      colSpan: 1,
      property: "bandwidth",
      type: "bits",
      format: "Kbps",
      width: "25%"
    },
    {
      title: tViews('userDataUsage'),
      colSpan: 1,
      property: "usage",
      type: "bytes",
      format: "GB",
      decimal: 1
    }
  ]
});

export default getDeviceTableConfig();
